import * as React from "react";
import axios from "axios";
import Box from "@mui/joy/Box";
import Autocomplete from "@mui/joy/Autocomplete";
import FormLabel from "@mui/joy/FormLabel";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { getCountries, getCities } from "countries-cities";

export default function Filtros({
  setCategoriaSeleccioanda,
  setNivelSeleccionado,
  setpaisseleccionado,
  setciudadseleccionada,
}) {
  let [categorias, setcategoria] = React.useState([]);
  let [niveles, setniveles] = React.useState([]);
  let [paises, setpaises] = React.useState(getCountries());
  let [ciudades, setciudades] = React.useState(false);
  let url = process.env.REACT_APP_FRONTEND_URL;

  React.useEffect(() => {
    let todaslascategorias = [];
    let todoslosniveles = [];
    let callcategorias = async () => {
      let categoriasyids = await axios.get(`${url}/api/categorias`);
      categoriasyids.data.map((valor, index) => {
        todaslascategorias.push(valor.nombre_categoria);
      });

      let nivelesyids = await axios.get(`${url}/api/niveles`);
      nivelesyids.data.map((valor, index) => {
        todoslosniveles.push(valor.nombre_nivel);
      });
    };
    callcategorias();
    todaslascategorias.push("Todas");
    todoslosniveles.push("Todos");
    setniveles(todoslosniveles);
    setcategoria(todaslascategorias);
    console.log("ciudades" + ciudades);
  }, []);

  /* EXPORTAR VALOR DEL AUTOCOMPLETE */

  let valorAutocomplete = (evento, nuevovalor) => {
    setCategoriaSeleccioanda(nuevovalor);
  };

  let nivelSeleccionado = (evento, nuevovalor) => {
    setNivelSeleccionado(nuevovalor);
  };
  let paiseleccionado = (evento, nuevovalor) => {
    setciudades(getCities(nuevovalor));
    setpaisseleccionado(nuevovalor);
    console.log("seleccione este pais" + nuevovalor);
  };
  let ciudadseleccionada = (evento, nuevovalor) => {
    setciudadseleccionada(nuevovalor);
    console.log("seleccione esta ciudad" + nuevovalor);
  };
  /* EXPORTAR VALOR DEL AUTOCOMPLETE */

  return (
    <Box
      sx={{ width: "100%", overflowX: "auto", whiteSpace: "nowrap", paddin: 1 }}
    >
      <FormLabel>Buscar por Categoria</FormLabel>
      <Autocomplete
        startDecorator={<FilterAltIcon />}
        placeholder="Filtrar por Categoria"
        options={categorias}
        sx={{ width: "100%", marginTop: "0.5rem" }}
        onChange={valorAutocomplete}
        disableClearable
      />
      <FormLabel sx={{ marginTop: "0.5rem" }}>Buscar por Nivel</FormLabel>
      <Autocomplete
        startDecorator={<FilterAltIcon />}
        placeholder="Filtrar por Nivel"
        options={niveles}
        sx={{ width: "100%", marginTop: "0.5rem" }}
        onChange={nivelSeleccionado}
        disableClearable
      />
      <FormLabel sx={{ marginTop: "0.5rem" }}>Buscar por Pais</FormLabel>
      <Autocomplete
        startDecorator={<FilterAltIcon />}
        placeholder="Filtrar por Pais"
        options={paises}
        sx={{ width: "100%", marginTop: "0.5rem" }}
        onChange={paiseleccionado}
        disableClearable
      />
      <FormLabel sx={{ marginTop: "0.5rem" }}>Buscar por Ciudad</FormLabel>
      <Autocomplete
        disabled={!ciudades}
        startDecorator={<FilterAltIcon />}
        placeholder="Filtrar por Ciudad"
        sx={{ width: "100%", marginTop: "0.5rem" }}
        onChange={ciudadseleccionada}
        options={ciudades}
        disableClearable
      />
    </Box>
  );
}
